/**
 * Delivery groups can describe either product lines or selected whole pallets.
 * A pallet-only order therefore remains valid even when it has no OrderLine rows.
 */
export function hasOrderContentForDelivery(order: {
  lines: readonly unknown[];
  pallets: readonly unknown[];
}): boolean {
  return order.lines.length > 0 || order.pallets.length > 0;
}
